import React, { useEffect, useRef } from "react";
import { FaQuoteLeft } from "react-icons/fa";

const ChairmanMessage = () => {
  const sectionRef = useRef(null);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fade-up");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    if (cardRef.current) observer.observe(cardRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-8 px-4 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-indigo-500/5 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="w-full px-4 md:px-8" ref={sectionRef}>
        <div className="text-center mb-8 animate-fade-in">
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            <span className="bg-gradient-to-r from-blue-600 via-indigo-500 to-blue-600 bg-clip-text text-transparent animate-gradient">
              Chairman's Message
            </span>
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            A vision for excellence, leadership, and global impact
          </p>
        </div>
        <div
          ref={cardRef}
          className="group opacity-0 transition-all duration-700 transform translate-y-8 hover:-translate-y-1 hover:shadow-xl rounded-2xl shadow-md overflow-hidden bg-gradient-to-br from-blue-50 via-white to-indigo-50 border-t-4 border-blue-500"
        >
          <div className="flex flex-col md:flex-row">
            <div className="md:w-1/3 p-6 bg-white/40 backdrop-blur-sm flex flex-col items-center text-center border-b md:border-b-0 md:border-r border-gray-100">
              <div className="w-40 h-40 md:w-56 md:h-56 rounded-full overflow-hidden bg-gradient-to-br from-blue-100 to-indigo-100 shadow-md mb-4">
                <img
                  src="/chairman.png"
                  alt="Sandeep Singh, Chairman RDS College Of Pharmacy"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-800">Sandeep Singh</h3>
              <p className="text-blue-600 font-semibold text-base">Chairman</p>
              <p className="text-gray-500 text-sm mb-4">RDS College Of Pharmacy</p>
              <div className="flex justify-center gap-6 w-full mt-2">
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600">25+</div>
                  <div className="text-xs text-gray-500">Years of Excellence</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-indigo-600">5+</div>
                  <div className="text-xs text-gray-500">Institutions</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600">1000+</div>
                  <div className="text-xs text-gray-500">Alumni Network</div>
                </div>
              </div>
            </div>
            <div className="md:w-2/3 p-6">
              <div className="flex items-start gap-2 mb-3">
                <FaQuoteLeft className="text-2xl text-blue-500 opacity-60" />
                <h3 className="text-lg font-semibold text-gray-800">A Word from Our Chairman</h3>
              </div>
              <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
                <p>
                  The fast changing business environment is changing tne mindset of the professionals. Today, 
                  nobody thinks only of winning the country's markets the view is on global markets and to 
                  get access to unexplored international business potential. The risks are high but the lure 
                  of returns is attracting corporates to new pastures. The future prom ses are to be even more 
                  challenging. A Professional today has to be much more familiar with the changing economic 
                  and business scene and should be in a position to use skills to best advantage. Innovative 
                  Institute has a crucia' role to play in the changing environment. We at Innovative train the 
                  upcoming pro'essionals not just in the traditional subjects. but also go much beyond the 
                  contemporary issues that affect today's busresses.
                </p>
                <p>
                  The global economy is poised for high growth and only profesSionals who can cope with this 
                  chalenging environment can become successful. Our curriculum addresses a higher degree of 
                  awareness to change and train the new generation professionals in skills that make them 
                  elective arid efficient professionals. We need to train them not only to become professionals 
                  but also to be effective leaders. Professionals should function with a vision that transcends 
                  boundaries and a quality of learning arid implementation as well. The Institute has enormous 
                  responsibility in building the confidence and leadership qualities In the upcu•i•ng professionals 
                  and to would their whole personality. We at Innovative Institutes have a vis:on that symbolizes 
                  dynamism and human values. We have worked out acurriculari that would dynamically address the 
                  issues of the future which will bring confidence and leadership in students.Corne, Join and 
                  share cur vision for a bright future.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes fade-up {
          from {
            opacity: 0;
            transform: translateY(2rem);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-up {
          animation: fade-up 0.6s ease-out forwards;
        }
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }
        @keyframes gradient {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
        .animate-gradient {
          background-size: 200% auto;
          animation: gradient 3s ease infinite;
        }
      `}</style>
    </section>
  );
};

export default ChairmanMessage;